import { Component, OnInit } from '@angular/core';
import { ProgressSpinnerMode, MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
    selector: 'ft-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    imports: [MatProgressSpinnerModule],
    standalone: true
})
export class LoadingComponent implements OnInit {

  mode: ProgressSpinnerMode = 'indeterminate';

  constructor() { }

  ngOnInit() {
  }

}

